import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-notification-guide',
    templateUrl: './notification-guide.component.html',
    standalone: false
})
export class NotificationGuideComponent implements OnInit {
  modalRef: BsModalRef;

  @Output() allowNotificationResult = new EventEmitter<boolean>();

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {

  }

  close = (selectedVal: boolean) => {
    this.modalService.hide();
    this.allowNotificationResult.emit(selectedVal);
  }
}
